import React from 'react';

import {WBSlateElementType} from '../../../components/Slate/WBSlate/types';
import ReportErrorBoundary from '../../ReportPage/ReportErrorBoundary';
import {TeamReadmeReady} from './TeamReadmeReady';

type TeamReadmeInnerProps = {
  readOnly: boolean;
  value: WBSlateElementType[];
  onChange: (newValue: WBSlateElementType[]) => void;
};

export const TeamReadmeInner: React.FC<TeamReadmeInnerProps> = ({
  readOnly,
  value,
  onChange,
}) => {
  return (
    <ReportErrorBoundary>
      <TeamReadmeReady readOnly={readOnly} value={value} onChange={onChange} />
    </ReportErrorBoundary>
  );
};
